import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import './index.scss';
import App from './App.tsx';
import { ErrorProvider } from './contexts/errorContext';
import { ThemeProvider } from './contexts/themeContext';
import { ToastProvider } from './contexts/toastContext';
import { initializeNewRelic } from './utils/newrelic';

// Initialize New Relic as early as possible
initializeNewRelic();

const rootElement = document.getElementById('root');
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000,
      gcTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    },
  },
});

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider>
          <ErrorProvider>
            <ToastProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </ToastProvider>
          </ErrorProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </StrictMode>,
  );
} else {
  console.error('Root element not found');
}
